import React, { FC, MouseEvent } from 'react';
import { IconButton, Box, BoxProps } from '@chakra-ui/core';
import { MinusAndText } from './minusAndText';
export interface Props extends BoxProps {
  value?: number;
  hideMinus?: boolean;
  noBorder?: boolean;
  name: string;
  addAction: (event: MouseEvent<HTMLButtonElement>) => void;
  minusAction: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const Counter: FC<Props> = ({
  value = 0,
  name,
  addAction,
  minusAction,
  hideMinus,
  noBorder,
  ...props
}) => {
  return (
    <Box
      d="flex"
      w="100%"
      h="4rem"
      border={noBorder ? 'none' : '1px solid'}
      borderColor="gray.500"
      borderRadius="0.4rem"
      alignItems="center"
      p="0.4rem 0.8rem 0.4rem 0.8rem"
      {...props}
    >
      {hideMinus ? (
        (value > 0) ? (
          <MinusAndText value={value} name={name} minusAction={minusAction} />
        ) : (
          <Box w="4.6rem"/>
        )
      ) : (
        <MinusAndText value={value} name={name} minusAction={minusAction} />
      )}
      <IconButton
        aria-label={`${name}-product-add`}
        icon="add"
        variant="outline"
        variantColor="primary"
        bg="transparent"
        borderColor="transparent"
        onClick={addAction}
        fontSize="6"
        w="3.2rem"
        h="3.2rem"
      />
    </Box>
  );
};
